import React from 'react';
import {
  defineMessages,
  useIntl,
} from 'react-intl';

const intlMessages = defineMessages({
  title: {
    id: 'modal.summary.title',
    description: 'Title for the summary modal',
    defaultMessage: 'Meeting Summary', // Fallback if translation missing
  },
});

const Header = () => {
  const intl = useIntl();

  return (
    <header className="modal-header">
      <h1>{intl.formatMessage(intlMessages.title)}</h1>
    </header>
  );
};

export default Header;
